import { reactive } from "vue";
import type { Player } from "./protocol";
function savedToken(): string {
  try {
    return JSON.parse(localStorage.getItem("user") || "{}").token || "";
  } catch {
    return "";
  }
}
export const session = reactive({
  token: savedToken(),
  player: null as Player | null,
  ready: false,
});
export function setPlayer(player: Player) {
  session.player = {
    ...player,
    Nick: player.Nick ?? player.user_name ?? player.UserName,
    UserName: player.phone || player.account || player.UserName,
  };
}
export function saveSession(player: Player) {
  session.token = player.Token || player.token;
  setPlayer(player);
  localStorage.setItem("user", JSON.stringify({ token: session.token }));
}
export function clearSession(expectedToken = session.token) {
  if (session.token !== expectedToken) return;
  // Another tab may already have stored its newly accepted login.
  if (savedToken() === expectedToken) localStorage.removeItem("user");
  session.token = "";
  session.player = null;
  session.ready = false;
  window.dispatchEvent(new Event("session-ended"));
}
